import { PartnerLog } from "../commonInterfaces"
import { PhoneTypes } from "./contacts"

export enum PartnerTypes {
    None = "",
    Church_or_Ministry = "Church/Ministry",
    Recreation = "Recreation",
    Clinic = "Clinic",
    Retail = "Retail",
    School = "School",
    Mercy = "Mercy",
    Restaurant = "Restaurant",
    Transportation = "Transportation",
    Hotel_or_Lodging = "Hotel/Lodging"
}

/** Partner PDF file from list endpoint (GCS). url is the signed view URL. */
export interface PartnerFile {
    name: string;
    url: string;
}

export interface ProfilesLocation {
    id: string;
    oldId?: number;
    name?: string;
    region?: string;
    domestic?: number;
    state?: string;
    city?: string;
    code?: string;
    lat?: number;
    lng?: number;
    public?: number;
    airport1?: string;
    airport2?: string;
    airport3?: string;
    population?: string;
    lang1?: string;
    lang2?: string;
    lang3?: string;
    eth1?: string;
    eth2?: string;
    eth3?: string;
    rel1?: string;
    rel2?: string;
    rel3?: string;
    infolink?: string;
    faq1?: string;
    faq2?: string;
    faq3?: string;
    faq4?: string;
    faq5?: string;
    faq6?: string;
    faq7?: string;
    faq8?: string;
    faq9?: string;
    faq10?: string;
    faq11?: string;
    faq12?: string;
    motto?: string;
    ind?: string;
    income?: string;
    climate?: string;
    basics?: string;
    cls?: string;
    econ?: string;
    food?: string;
    history?: string;
    snippet?: string;
    summary?: string;
    active?: number;
    modified?: string;
    featured?: number;
    url?: string;
    restricted?: number;
    video?: string;
    displayInterestVideo?: number;
    alpha?: string;
    metaDescription?: string;
    domesticRegion?: string;
    shortname?: string;
    donationDocId?: string;
    reentryStatus: number;
    reentryOutlook?: string;
    reentryTiming?: string;
    nameCr?: string;
    publicCr?: number;
    lang1Cr?: string;
    lang2Cr?: string;
    lang3Cr?: string;
    eth1Cr?: string;
    eth2Cr?: string;
    eth3Cr?: string;
    rel1Cr?: string;
    rel2Cr?: string;
    rel3Cr?: string;
    infolinkCr?: string;
    mottoCr?: string;
    climateCr?: string;
    basicsCr?: string;
    clsCr?: string;
    econCr?: string;
    foodCr?: string;
    historyCr?: string;
    snippetCr?: string;
    summaryCr?: string;
    regionCr?: string;
    nameHt?: string;
    publicHt?: number;
    lang1Ht?: string;
    lang2Ht?: string;
    lang3Ht?: string;
    eth1Ht?: string;
    eth2Ht?: string;
    eth3Ht?: string;
    rel1Ht?: string;
    rel2Ht?: string;
    rel3Ht?: string;
    infolinkHt?: string;
    mottoHt?: string;
    climateHt?: string;
    basicsHt?: string;
    clsHt?: string;
    econHt?: string;
    foodHt?: string;
    historyHt?: string;
    snippetHt?: string;
    summaryHt?: string;
    regionHt?: string;
    advisory?: string;
    displayAdvisory: number;
    advisoryCr?: string;
    advisoryHt?: string;
    recruitingQuicknote?: string;
    manager365?: number;
    managerBio365?: string;
    landing365: number;
    managerBio365Cr?: string;
    donationForm365?: string;
    readinessLocation: number;
    opsRegionId: number;
  }  

export interface AssignedPartnershipInfo {
    subtripId: string,
    partial: boolean,
    partnership: {
        partners: ProfilesPartner[],
        communities: ProfilesCommunity[],
        contacts: ProfilesContact[]
    },
    assignments: {
        partners: TripsPartner[],
        communities: TripsCommunity[],
        contacts: TripsContact[]
    }
  
}

export interface PartnershipStatus {
    public: number,
    confirmed: number,
    isPrimary?: number,
    isLodging?: number,
    isAdditional?: number
}
export interface PartnershipInfo {
    partners: ProfilesPartner[],
    communities: ProfilesCommunity[],
    contacts: ProfilesContact[]
}

export interface PartnershipDropdownInfo {
    partners: DropdownPartner[],
    communities: DropdownCommunity[],
    contacts: DropdownContact[]
}

export interface DropdownPartner extends Pick<ProfilesPartner , "name" | "id" | "locId" | "comId">{}
export interface DropdownCommunity extends Pick<ProfilesCommunity, "name" | "id" | "locId"> {}
export interface DropdownContact extends Pick<ProfilesContact, "firstname" | "lastname" | "id" | "locId" | "partnerId"> {
  displayName?: string;
}

export interface TripsPartner {
    tripsPartnerId: number,
    subtripId: string,
    partnerId: string,
    confirmed: number,
    public: number,
    timestamp: Date,
    isPrimary?: number,
    isLodging?: number,
    isAdditional?: number
}

export interface TripsCommunity {
    tripsCommunityId: number,
    subtripId: string,
    communityId: string,
    confirmed: number,
    public: number,
    timestamp: Date
}

export interface TripsContact {
    tripsContactId: number,
    subtripId: string,
    contactId: string,
    confirmed: number,
    public: number,
    timestamp: Date
}

export interface ProfilesPartner {
    id: string;
    locId?: string;
    comId?: string;
    oldId?: number;
    oldlocId?: number;
    oldcomId?: number;
    name: string;
    type?: PartnerTypes;
    lat?: number;
    lng?: number;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zipcode?: string;
    district?: string;
    phone1?: string;
    phone2?: string;
    fax?: string;
    website?: string;
    email?: string;
    facebook?: string;
    twitter?: string;
    googleplus?: string;
    youtube?: string;
    othersocial?: string;
    description?: string;
    vision?: string;
    mission?: string;
    lodging?: number;
    capacity?: number;
    rooms?: number;
    showers?: number;
    toilets?: number;
    denomination?: string;
    attendmax?: number;
    attendavg?: number;
    students?: number;
    shipAddress1?: string;
    shipAddress2?: string;
    shipCity?: string;
    shipState?: string;
    shipZipcode?: string;
    classes?: number;
    rating?: number;
    value?: number;
    active?: number;
    resttype?: string;
    rectype?: string;
    residents?: number;
    units?: number;
    tuition?: number;
    cost?: number;
    hotelcap?: number;
    hotelrooms?: number;
    mercytype?: string;
    parkLat?: number;
    parkLng?: number;
    parkNote?: string;
    parkCost?: number;
    lodgingNotes?: string;
    minChild?: number;
    minChildNotes?: string;
    minServe?: number;
    minServeNotes?: string;
    minChurch?: number;
    minChurchNotes?: string;
    minSports?: number;
    minSportsNotes?: string;
    minPrayer?: number;
    minPrayerNotes?: string;
    minSchool?: number;
    minSchoolNotes?: string;
    minMercy?: number;
    minMercyNotes?: string;
    minEvang?: number;
    minEvangNotes?: string;
    minYouth?: number;
    minYouthNotes?: string;
    minAdult?: number;
    minAdultNotes?: string;
    minMedical?: number;
    minMedicalNotes?: string;
    minOther1?: number;
    minOther1Name?: string;
    minOther1Notes?: string;
    minOther2?: number;
    minOther2Name?: string;
    minOther2Notes?: string;
    descriptionPublic?: string;
    visionPublic?: string;
    missionPublic?: string;
    modified?: Date;
    photo?: number;
    wifi?: number;
    ssid?: string;
    wifipass?: string;
    inactive?: number;
    timezone?: string;
    lodgingType?: string;
    video?: string;
    recDefault?: number;
    ppm365?: number;
    disaster?: number;
    funded?: number;
    numericId?: number;
}

export interface ProfilesCommunity {
    id: string;
    locId: string;
    oldId?: number;
    oldlocId?: number;
    name: string;
    lat?: number;
    lng?: number;
    size?: number;
    population?: string;
    district?: string;
    occ1?: string;
    occ2?: string;
    occ3?: string;
    airport?: string;
    distance?: number;
    summary?: string;
    barriers?: string;
    needs?: string;
    active?: number;
    summaryPublic?: string;
    barriersPublic?: string;
    needsPublic?: string;
    modified?: Date;

}

export interface ProfilesContact {
    id: string;
    locId: string;
    comId: string;
    partnerId: string;
    oldId?: number;
    oldlocId?: number;
    oldcomId?: number;
    oldpartnerId?: number;
    firstname?: string;
    middlename?: string;
    lastname?: string;
    prefix?: string;
    jobtitle?: string;
    role?: string;
    address1?: string;
    address2?: string;
    city?: string;
    district?: string;
    zipcode?: string;
    country?: string;
    phone1?: string;
    phone1ext?: string;
    phone1type?: PhoneTypes;
    phone2?: string;
    phone2ext?: string;
    phone2type?: PhoneTypes;
    fax?: string;
    email?: string;
    active?: number;
    descriptionPublic?: string;
    description?: string;
    facebook?: string;
    twitter?: string;
    googleplus?: string;
    youtube?: string;
    othersocial?: string;
    state?: string;
    lat?: number;
    lng?: number;
    gender?: number;
    birthday?: Date;
    phone3?: string;
    phone4?: string;
    phone5?: string;
    phone3ext?: string;
    phone4ext?: string;
    phone5ext?: string;
    phone3type?: PhoneTypes;
    phone4type?: PhoneTypes;
    phone5type?: PhoneTypes;
    modified?: Date;
    photo?: number;
}

export interface PartnershipStats {
    activePartnerships: number;
    totalPartnerships: number;
}

export interface PartnerLogForStaff extends PartnerLog {
    staffName: string;
    assignName: string | null;
    partnerName: string;
    contactName: string | null;
}
